export default "__VITE_ASSET__c2561e59__"